import React from "react";
import WiresActivityPage, { getDefaultData, getDefaultUI } from "components/pages/WiresActivityPage";
import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import Classes from "model";

/**
 * @name Capture002WireActivity
 * @returns {React.Component}
 * @description - A capture in capture group "Wire Activity".
 */
export default function Capture002WireSelected() {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const defaultData = getDefaultData();
    const defaultUI = getDefaultUI();
    const pendingTransfers = defaultData.pendingWireWidgetData.oneTimeWireTransfers;

    const updatedPendingTransfers = pendingTransfers.map(item => {
        item.isChecked = true;
        return item;
    });

    const data = BCMSStateManagerCRUD.init(defaultData)
        .update(["pendingWireWidgetData", "oneTimeWireTransfers"], updatedPendingTransfers)
        .submit();

    const ui = BCMSStateManagerCRUD.init(defaultUI)
        .update(["pendingWireWidgetUI", "isCheckedAll"], true)
        .update(["pendingWireWidgetUI", "isRejectedDisabled"], false)
        .update(["pendingWireWidgetUI", "isApprovedDisabled"], false)
        .submit();

    return <WiresActivityPage data={data} ui={ui} />;
}